import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function PriceTag({ idVariant = '', className }: Props) {
  return (
    <IconBase name="price-tag" w={26} className={className}>
      <path d="M19.6003 4.59911C20.5944 4.59911 21.4003 5.40502 21.4003 6.39916C21.4003 7.39331 20.5944 8.19922 19.6003 8.19922C18.6062 8.19922 17.8003 7.39331 17.8003 6.39916C17.8003 5.40502 18.6062 4.59911 19.6003 4.59911Z" stroke="currentColor" strokeWidth="1.38462" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.9999 15.3998L10.5999 19M1.92867 11.9725C0.725063 13.3166 0.699863 15.3446 1.80387 16.7727C3.94829 19.5565 6.44336 22.0516 9.22711 24.1961C10.6551 25.3001 12.6831 25.2749 14.0271 24.0713C17.6603 20.8214 21.0741 17.3345 24.2464 13.6334C24.5667 13.2653 24.7639 12.8063 24.8104 12.3205C25.0072 10.1653 25.414 3.95628 23.728 2.27143C22.042 0.586577 15.8344 0.992189 13.6791 1.1902C13.1934 1.23673 12.7344 1.43393 12.3663 1.75421C8.66536 4.92617 5.17851 8.33974 1.92867 11.9725Z" stroke="currentColor" strokeWidth="1.38462" strokeLinecap="round" strokeLinejoin="round"/>
    </IconBase>
  )
}

export default PriceTag
